import { CheckboxList } from "./CheckboxList";
import { getStages } from "../pages/Jobs/job-stages";

export const StatusFilterList = (props) => {
  const stages = getStages();

  const statusList = Object.values(stages).map((stage) => {
    return { id: stage.id, name: stage.title };
  });

  function handleChange(val) {
    if (!val || val.length === 0) {
      props.onChange({
        title: props.value?.defaultText || "",
        value: "",
      });
      return;
    }

    // Send canonical stage ids to API (ex: dispatched, in_progress)
    // so filters work consistently across environments.
    const value = val.map(({ id }) => id).join(",");
    const title = val.map(({ name }) => name).join(",") || props.value?.defaultText;

    if (value) {
      props.onChange({ title, value });
    }
  }

  return (
    <CheckboxList
      onChange={handleChange}
      objectKey="id"
      value={props.value.value}
      data={statusList}
    />
  );
};
